import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const BUTTON = derivedThemeValues(_ref => {
  let {
    theme,
    radius,
    remCalc
  } = _ref;
  return {
    fontWeight: theme.base.fontSemibold,
    borderRadius: radius(2),
    default: {
      backgroundColor: '#e2e5eb',
      foregroundColor: '#000000',
      ringColor: '#3259e8',
      hover: {
        backgroundColor: '#c3c9d1'
      }
    },
    small: {
      height: remCalc(34),
      padding: remCalc(8)
    },
    medium: {
      height: remCalc(42),
      padding: remCalc(10)
    },
    large: {
      height: remCalc(50),
      padding: remCalc(12)
    }
  };
});